









import { Component, Emit, Model, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import NumUtils from "@/utils/numUtils";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class CoinsTitle extends Vue {
  @Getter(types.GETTER_MASTER_COINS)
  private userCoins: any;

  get format() {
    return NumUtils.format;
  }
}
